import { IQueryProps } from '@/entities/Query'
import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class FetchScheduleUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute(query?: IQueryProps) {
    try {
      await refresh(this.App)
      return await this.App.monitaroGateway.Schedule.FetchSchedule(query)
    } catch (exception: any) {
      this.App.logService.handle(exception)
    }
    return null
  }
}
